/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as deepDiff from 'odiff';
import { processComponentName } from './utils/helpers';

const COMPONENT_TELEMETRY = 'componentTelemetry';

enum Configs {
    DEEP = 'deep',
    SHALLOW = 'shallow'
}

interface IEntry {
    key: string;
    value: Record<string, any>;
    action: string;
}

export const getShallowDiff = (prevObject: any, newObject: any): IEntry[] => {
    const prevObjectKeys = Object.keys(prevObject);
    const newObjectKeys = Object.keys(newObject);

    const removedEntries: IEntry[] = [];
    prevObjectKeys.forEach((key: string) => {
        if (!newObject.hasOwnProperty(key)) {
            removedEntries.push({
                key,
                value: prevObject[key],
                action: 'removed'
            });
        }
    });

    const newEntries: IEntry[] = [];
    newObjectKeys.forEach((key: string) => {
        if (newObject[key] !== prevObject[key]) {
            newEntries.push({
                key,
                value: newObject[key],
                action: prevObject.hasOwnProperty(key) ? 'modified' : 'added'
            });
        }
    });

    return [...removedEntries, ...newEntries];
};

export const logPropDiff = (
    config: Configs,
    prevProps: any,
    props: any,
    componentName: string = '',
    callCount: number
) => {
    const diff =
        config === Configs.DEEP ? deepDiff(prevProps, props) : getShallowDiff(prevProps, props);

    // eslint-disable-next-line no-console
    console.log(`${componentName} Render #${callCount}:`, diff);
};

export function componentTelemetry(customName?: string | (() => string) | string) {
    const componentTelemetryConfig = localStorage.getItem(COMPONENT_TELEMETRY);
    if (componentTelemetryConfig === Configs.DEEP || componentTelemetryConfig === Configs.SHALLOW) {
        let callCount = 0;

        return (WrappedComponent: React.ComponentType) => {
            const componentName = processComponentName(
                WrappedComponent.displayName || 'UnnamedReactComponent',
                customName
            );

            return class extends React.Component {
                constructor(props: any) {
                    super(props);
                }
                componentDidMount() {
                    callCount++;

                    logPropDiff(componentTelemetryConfig, {}, this.props, componentName, callCount);
                }

                componentDidUpdate(prevProps: any) {
                    callCount++;

                    logPropDiff(
                        componentTelemetryConfig,
                        prevProps,
                        this.props,
                        componentName,
                        callCount
                    );
                }

                public render() {
                    return <WrappedComponent {...this.props} />;
                }
            };
        };
    }

    return (WrappedComponent: React.ComponentType): any => WrappedComponent;
}
